export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "bundle.3446b0a0dc1e8041f79e.worker.js");
}
